export default function HomePage({ logedIn }) {

    return (
        <div className="my-5">
            <p className="text-center text-white font-weight-bold">{
                `Debés ${logedIn ? 'elegir una unidad' : 'iniciar sesión'} para poder relizar una consulta`
            }</p>
        </div>
    );
}